<template>
  <div class="sidemenu widget sticky search-filters">
    <div class="border-0 border-b-2 border-solid border-gray-medium pb-2 flex flex-row">
      <button
        aria-label="toggle filter option"
        class="`button mr-4 py-0 px-2 icon-button filter-button"
        @click="isFilterShown = !isFilterShown"
      >
        <FilterIcon class="filter-icon" />
      </button>
      <div class="flex items-center">
        <p class="h5 mb-1">
          {{ $t('dataPortal.filterHeader') }}
        </p>
      </div>
    </div>

    <div v-show="isFilterShown">
      <div>
        <checkbox-two-level
          :values="queryParam.subjectAreas"
          :data-list="tagOptions?.subjectAreas"
          :label="$t('dataPortal.list.subjectAreas')"
          :max-item-shown="400"
          :is-collapsable="true"
          :css="'mt-2'"
          :is-init-expanded="true"
          :list-css="'mt-2'"
          @update:check-result="(result) => { updateOption('subjectAreas', result); }"
        />
      </div>
      <div>
        <checkbox-two-level
          :values="queryParam.tags"
          :data-list="tagOptions?.tags"
          :label="$t('dataPortal.list.tags')"
          :max-item-shown="4"
          :is-collapsable="true"
          :css="'mt-2'"
          :list-css="'mt-2'"
          @update:check-result="(result) => { updateOption('tags', result); }"
        />
      </div>
      <!-- Remove v-if once we have better data type -->
      <div v-if="false">
        <checkbox-two-level
          :values="queryParam.dataType"
          :data-list="tagOptions?.dataType"
          :label="$t('dataPortal.list.dataType')"
          :is-single-selection="true"
          :is-collapsable="true"
          :css="'mt-2'"
          @update:check-result="(result) => { updateOption('dataType', result); }"
        />
      </div>
    </div>
  </div>
  <!-- <div>{{ tags }}</div> -->
</template>

<script setup lang="ts">
import CheckboxTwoLevel from '@/components/checkbox/CheckboxTwoLevel.vue';
import FilterIcon from '@/assets/filter-funnel.svg';
import { dataDownloadSearchState, requestKeys } from '@/composables/state/dataDownloadSearchApp';
import { scrollToTopWithOffset } from '@/config/common';
import stickybits from 'stickybits';
import { onMounted, ref } from 'vue';

const {
  tagOptions, queryParam, updateFilter
} = dataDownloadSearchState();
const isFilterShown = ref(true);

const updateOption = (fieldName: requestKeys, resultList: string[]) => {
  ((queryParam.value)[fieldName] as unknown) = resultList;
  updateFilter();
  // Select the element you want to scroll to
  scrollToTopWithOffset('#scrollToHere', 100);
};

const onResize = () => {
  // prevents users from getting stuck when they resize to a bigger screen
  if (window.innerWidth > 1024) {
    isFilterShown.value = true;
  }
};

/* sticky doesn't seem to work */
onMounted(() => {
  stickybits('.sidemenu.widget.sticky', {
    useStickyClasses: true,
    stickyBitStickyOffset: 110
  });

  window.addEventListener('resize', onResize);
});
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

button.svg {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
.filter-font {
  font-size: 15px;
}
.filter-header {
  font-size: 18px;
}

.filter-icon {
  stroke: black;
  height: 1lh;
}

@media only screen and (min-width: 1024px) {
  .filter-button {
    display: none;
  }
}
</style>
